import React, { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import { VNode } from "preact";

// component
import CustomBreadcrumb from "src/components/CustomBreadcrumb";
import Header from "src/components/Header";
import Sidebar from "src/components/Sidebar";

import { allRoutes } from "src/constants/AllRoutes";
import { isSuperAdmin } from "src/utils/users";
import "./auth-layout.scss";

function UserLayout(): VNode<any> {
  const [is_Open, setIsOpen] = useState(false);
  const superAdmin = isSuperAdmin();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    function handleUnauthorised() {
      navigate(allRoutes.login);
    }
    window.addEventListener("unauthorised", handleUnauthorised);
    return () => {
    window.removeEventListener("unauthorised", handleUnauthorised);
    };
  }, []);
  useEffect(() => {
    if (!superAdmin && location.pathname === allRoutes.dashboard) {
      navigate(allRoutes.itinerary);
    }
  }, [!superAdmin && location.pathname === allRoutes.dashboard]);

  if (!superAdmin && location.pathname === allRoutes.dashboard) {
    navigate(allRoutes.itinerary);
    return null;
  }

  return (
    <div className="user-layout">
      <Sidebar is_Open={is_Open} setIsOpen={setIsOpen} isSuperAdmin={isSuperAdmin()} />
      <div className="main-container d-flex flex-column vh-100">
        <Row>
          <Col className="pe-0">
            <CustomBreadcrumb />
          </Col>
          <Col className="ps-0">
            <Header is_Open={is_Open} setIsOpen={setIsOpen} />
          </Col>
        </Row>
        <div className="user-layout-inner container-fluid bg-white pb-3 flex-grow-1 d-flex flex-column">
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default UserLayout;
